import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import noImageAvailable from "../assets/no_image.png";
import { getVipBoxes, setSelectedBox, setSelectedLevelBox } from "../features/boxSlice";
import { FaEdit as EditIcon, FaEye as ViewIcon } from "react-icons/fa";
import { AppDispatch, RootState } from "../app/store";
import { Box, LevelBox } from "../modal/box";
import useConfirmation from "../components/confirm_modal";
import { Icon, IconButton, Spinner } from "../styles/GlobalStyles";
import { toast, ToastContainer } from "react-toastify";
import { getImagePath } from "../utils/utils";
import styled from "styled-components";
import ManageLevelBoxPage from "./manage_level_box_page";
import Modal from "../components/modal";
import { useNavigate } from "react-router-dom";

// Styled components for layout and styling
const Container = styled.div`
  width: 100%;
  overflow-x: auto;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  th, td {
    padding: 0.5rem;
    text-align: left;
    border-bottom: 1px solid #ddd;
  }

  th {
    background-color: #f4f4f4;
  }

  td {
    &:nth-child(1) {
      width: 5%;
    }
    &:nth-child(2) {
      width: 10%;
    }
    &:nth-child(3) {
      width: 20%;
    }
    &:nth-child(4) {
      width: 45%;
    }
    &:nth-child(5) {
      width: 10%;
    }
    &:nth-child(6) {
      width: 5%;
    }
    &:nth-child(7) {
      width: 5%;
    }
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const LevelBoxesPage: React.FC = () => {
    const levels = useSelector((state: RootState) => state.boxes.levelBoxes);
    const dispatch: AppDispatch = useDispatch();
    const { confirm, ConfirmationModal } = useConfirmation();
    const navigate = useNavigate();

    const [isModalOpen, setModalOpen] = useState(false);

    useEffect(() => {
        dispatch(getVipBoxes());
    }, [dispatch]);

    const updateBoxScreen = (box: Box) => {
        dispatch(setSelectedBox(box));
        navigate(`/dashboard/boxes/details/${box.id}`);
    };

    const openUpdateLevelModal = (level: LevelBox) => {
        dispatch(setSelectedLevelBox(level));
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
        setSelectedLevelBox(null);
    };


    const handleOpenModal = () => {
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
    };


    return (
        <>
            <Container>
                <ToastContainer />
                <StyledTable>
                    <thead>
                        <tr>
                            <th>Level</th>
                            <th>Name</th>
                            <th>Box Name</th>
                            <th>Description</th>
                            <th>Value</th>
                            <th>Stock Count</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {levels.map((level, levelIndex) =>
                            level.box != null ? (
                                <tr key={`${levelIndex}-${levelIndex}`}>
                                    <td>{levelIndex}</td>
                                    <td>{level.name}</td>
                                    <td>
                                        <ImageWrapper>
                                            {level.box.picture ? (
                                                <img
                                                    src={getImagePath(level.box.picture)}
                                                    alt="Image"
                                                    style={{ width: '48px', height: '48px', objectFit: 'contain' }}
                                                />
                                            ) : (
                                                <img
                                                    src={noImageAvailable}
                                                    alt="No Image"
                                                    style={{ width: '48px', height: '48px', objectFit: 'contain' }}
                                                />
                                            )}
                                            <div>{level.box.name}</div>
                                        </ImageWrapper>
                                    </td>
                                    <td>{level.box.description}</td>
                                    <td>${level.box.final_value}</td>
                                    <td>{level.box.stock_count}</td>
                                    <td>
                                        <IconButton onClick={() => updateBoxScreen(level.box!)}>
                                            <Icon><ViewIcon /></Icon>
                                        </IconButton>
                                        <IconButton onClick={() => openUpdateLevelModal(level)}>
                                            <Icon><EditIcon /></Icon>
                                        </IconButton>
                                    </td>
                                </tr>
                            ) : (
                                <tr key={levelIndex}>
                                    <td>{levelIndex}</td>
                                    <td>{level.name}</td>
                                    <td colSpan={4} style={{ color: 'red' }}>
                                        Level {level.level} has no box assigned.
                                    </td>
                                    <td>
                                        <IconButton onClick={() => openUpdateLevelModal(level)}>
                                            <Icon><EditIcon /></Icon>
                                        </IconButton>
                                    </td>
                                </tr>
                            )
                        )}
                    </tbody>
                </StyledTable>
                <ConfirmationModal />
            </Container>
            {/* Modal for updating level box */}
            {isModalOpen && (
                <Modal isOpen={isModalOpen} onClose={closeModal} title="Update Level Box">
                    <ManageLevelBoxPage isOpen={isModalOpen} onClose={handleCloseModal} />
                </Modal>
            )}
        </>
    );
};

export default LevelBoxesPage;
